module.exports = __webpack_public_path__ + "media/images/colonial-647f7fe43eab1333d941c1fbc8ad2398.jpg";